import D2C_Service from '../Service'

class D2C_ServiceData extends D2C_Service {
  isDb = true
  static objectType = 'serviceRole'
  static groupTitle = 'Data'
  static roleName = 'data'
  static roleTitle = 'Data'
  static fields = {
    ...D2C_Service.fields,
    version: {
      ...D2C_Service.fields.version,
      updating: {
        ...D2C_Service.fields.version.updating,
        warning: 'Be careful!\nSome databases require manual data migration to a new version.\nMake sure you\'ve made a backup before changing the version.'
      }
    }
  }
}

export default D2C_ServiceData
